import { isPlatform } from "@ionic/vue";
import {GuildRank} from "@/enums";

export const getters = {
    isLocal: () => {
        return import.meta.env.VITE_ENV === 'local';
    },
    isTesting: () => {
        return import.meta.env.VITE_ENV === 'testing';
    },
    isProduction: () => {
        return import.meta.env.VITE_ENV === 'production';
    },
    isNative: () => {
        // TODO: MORE ELABORATE VERIFICATION
        // REMEMBER TO UPDATE routes FOR '/' IF UPDATING
        // https://ionicframework.com/docs/vue/platform
        return isPlatform('android') || isPlatform('ios');
    },
    loggedIn: state => {
        return state.id !== null;
    },
    isSetup: state => {
        return state.coppa !== null;
    },
    // TODO: IS THIS USED?
    disconnected: state => {
        return state.echo.state === 'disconnected';
    },
    // TODO: IS THIS USED?
    connecting: state => {
        return state.echo.state === 'connecting';
    },
    connected: state => {
        return state.echo.state === 'connected';
    },
    // TODO: CHANGE THESE METHODS TO MATCH SERVER-SIDE NOMENCLATURE
    guilded(state) {
        return this.loggedIn && state.guild !== null;
    },
    bracketed(state) {
        return this.guilded && state.guild.bracket !== null;
    },
    isGuildLeader(state) {
        return this.guilded && state.guild.members.find(m => m.id === state.id).guild_rank === GuildRank.LEADER;
    },
    isGuildOfficer(state) {
        return this.guilded && state.guild.members.find(m => m.id === state.id).guild_rank === GuildRank.OFFICER;
    },
    isGuildLeadership() {
        return this.isGuildLeader || this.isGuildOfficer;
    },
    isGuildMember(state) {
        return this.guilded && state.guild.members.find(m => m.id === state.id).guild_rank === GuildRank.MEMBER;
    },
    charactersDetailed: state => {
        return state.characters.filter(character => {
            return state.references.data.design.character.find(c => c.id === character.id) !== undefined;
        })
            .map(character => {
                const points = state.character_points.find(c => c.id === character.id);
                const tier = state.tier_costs.find(t => t.id === character.tier + 1);
                const reference_character = state.references.data.design.character.find(c => c.id === character.id);
                const passiveRef = (state.references.data.design.passive || []).find(p => p.character_id === character.id);
                return Object.assign({},
                    character,
                    {
                        name: reference_character.name,
                        flavor: reference_character.flavor,
                        bluster: reference_character.bluster,
                        taunt: reference_character.taunt,
                        title: reference_character.title,
                        passive: passiveRef ? passiveRef.name : null,
                        passive_description: passiveRef ? passiveRef.description : null,
                        division_id: reference_character.division_id,
                        rank: reference_character.rank,
                        activeAttributePoints: character.character_trees.find(c => c.active).attributes.reduce((total, entry) => {
                            return total + entry.val;
                        }, 0),
                        points: points === undefined ? 0 : points.quantity,
                        nextTierCost: tier === undefined ? undefined : tier.cost,
                        canAffordTierUpgrade: tier !== undefined && points !== undefined && points.quantity >= tier.cost,
                        divisions: state.references.data.design.division.map(division => {
                            const found = character.divisions.find(d => d.id === division.id);
                            const previous_divisions = character.divisions.filter(d => d.id < division.id);
                            return Object.assign({}, division, {
                                unlocked: found !== undefined,
                                mayUnlock: found === undefined && previous_divisions.filter(d => d.difficulty > division.prerequisite).length === previous_divisions.length,
                                difficulty: found === undefined ? null : found.difficulty,
                                daily_rewards: found === undefined ? null : (found.daily_rewards || null),
                            });
                        }),
                    },
                );
            });
    },
    unreadNotifications: state => {
        return state.notifications.reduce((total, n) => {
            return total + (n.read_at === null ? 1 : 0);
        }, 0);
    },
    activeSales: state => {
        return state.sales.filter(sale => {
            // TODO: FILTER OUT FUTURE/PAST SALES STILL IN ARRAY
            return typeof sale === 'object';
        });
    },
    availableChests: state => {
        if (!state.references.data || !state.references.data.design || !state.references.data.design.chest) {
            return [];
        }
        return state.references.data.design.chest.filter(c => {
            const chest_limit = state.limited_chests.find(l => l.id === c.id);
            return chest_limit === undefined || c.max_purchases === null || c.max_purchases > chest_limit.amount;
        });
    },
    currentSales(state) {
        const now = Math.round(Date.now() / 1000);
        const chests = this.availableChests;
        return state.sales.filter(s => {
            return typeof s === 'object' && s.start <= now && s.end >= now;
        }).map(sale => {
            const saleChests = [];
            sale.discounts.forEach(d => {
                const discount_limit = state.limited_discounts.find(l => l.id === d.id);
                if (d.max_purchases === null || discount_limit === undefined || d.max_purchases > discount_limit.amount) {
                    const chest = chests.find(c => c.id === d.chest_id);
                    if (chest) {
                        saleChests.push(Object.assign({}, chest, {discount: d}));
                    }
                }
            });
            return {
                chests: saleChests,
                name: sale.name,
                description: sale.description,
                image_1: sale.image_1,
                image_2: sale.image_2,
                image_3: sale.image_3,
                start: sale.start,
                end: sale.end,
            };
        }).filter(s => s.chests.length > 0);
    },
};
